import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'
import createPresistedState from 'vuex-persistedstate'
import modules from '@/store/modules'
import { uaIsIOS, uaIsAndroid, uaIsTablet } from '@/utils/helpers'

Vue.use(Vuex)

interface State {
  currentBasePageName: string
  fromName: string
  fromRouterNames: string[]
  transitionName: string
  fromStoreModuleName: string
  currentSavedPosition: { x: number; y: number }
  recentRouteNames: string[]
}

const defaultState: State = {
  currentBasePageName: '',
  fromName: '',
  fromRouterNames: [],
  transitionName: '',
  fromStoreModuleName: '',
  currentSavedPosition: { x: 0, y: 0 },
  recentRouteNames: []
}

const state: State = { ...defaultState }

const mutations = {
  setCurrentBasePageName(state: State, basePageName: string) {
    state.currentBasePageName = basePageName
  },
  setFromName(state: State, name: string) {
    state.fromName = name
  },
  /**
   * Vue Router の履歴を10件まで保存
   */
  addedFromRouterNames(state: State, name: string) {
    state.fromRouterNames.unshift(name)
    if (state.fromRouterNames.length > 10) {
      state.fromRouterNames.pop()
    }
  },
  setTransitionName(state: State, name: string) {
    state.transitionName = name
  },
  setFromStoreModuleName(state: State, name: string) {
    state.fromStoreModuleName = name
  },
  setCurrentSavedPosition(state: State, currentSavedPosition: { x: number; y: number }) {
    state.currentSavedPosition = currentSavedPosition
  },
  addRecentRouteNames(state: State, routeName: string) {
    state.recentRouteNames.unshift(routeName)
    if (state.recentRouteNames.length > 10) {
      state.recentRouteNames.pop()
    }
  }
}

const getters = {
  URL_SCHEME: (): string => config.URL_SCHEME,
  SERVER_URL: (): string => config.SERVER_URL,
  D_SERVER_URL: (): string => config.D_SERVER_URL,
  FRONT_URL: (): string => config.FRONT_URL,
  MOBILE_URL: (): string => config.MOBILE_URL,
  WEB_URL: (): string => config.WEB_URL,
  PAYMENT_URL: (): string => config.PAYMENT_URL,
  NOTIFICATION_CHANNEL_ID: (): string => config.NOTIFICATION_CHANNEL_ID,
  SUPPORT_TIME: (): string => config.SUPPORT_TIME,
  NOIMG_MAN_URL: (): string => config.NOIMG_MAN_URL,
  NOIMG_WOMAN_URL: (): string => config.NOIMG_WOMAN_URL,
  UA_IS_IOS: (): boolean => uaIsIOS,
  UA_IS_ANDROID: (): boolean => uaIsAndroid,
  UA_IS_TABLET: (): boolean => uaIsTablet,
  currentBasePageName: (state: State): string => state.currentBasePageName,
  fromName: (state: State): string => state.fromName,
  fromRouterNames: (state: State): string[] => state.fromRouterNames,
  transitionName: (state: State): string => state.transitionName,
  fromStoreModuleName: (state: State): string => state.fromStoreModuleName,
  currentSavedPosition: (state: State): { x: number; y: number } => state.currentSavedPosition,
  recentRouteNames: (state: State): string[] => state.recentRouteNames
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules,
  plugins: [createPresistedState()]
})
